// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Leve2QuoteType } from '@shared/utils/Enums/Constants';
import { MathUtils } from '@shared/utils/MathUtils';
export var Level2Type;
(function (Level2Type) {
    // Коллекция бидов - сортировка по убыванию
    Level2Type[Level2Type["Bids"] = 0] = "Bids";
    // Коллекция асков - сортировка по возрастанию
    Level2Type[Level2Type["Asks"] = 1] = "Asks";
})(Level2Type || (Level2Type = {}));
export var CompareType;
(function (CompareType) {
    CompareType[CompareType["Price"] = 0] = "Price";
    CompareType[CompareType["PriceSize"] = 1] = "PriceSize";
    CompareType[CompareType["PriceTimeSize"] = 2] = "PriceTimeSize";
})(CompareType || (CompareType = {}));
export var Filter;
(function (Filter) {
    Filter[Filter["None"] = 0] = "None";
    Filter[Filter["MinusOne"] = 1] = "MinusOne";
    Filter[Filter["Time"] = 2] = "Time";
    Filter[Filter["Size"] = 4] = "Size";
})(Filter || (Filter = {}));
export class Level2Collection {
    constructor(si, l2Type, ins) {
        this.topLevelItem = null;
        this.change = false;
        this.itemsArr = [];
        this.items = {};
        this.Level2Type = l2Type;
        this.SpreadItem = si;
        this.comparer = new Level2ItemComparer(this.Level2Type === Level2Type.Bids);
        this.instrumentPrecision = ins === null ? -1 : ins.getPrecision();
        this.reverse = this.Level2Type === Level2Type.Bids;
    }
    static Synchronized(si, l2Type, ins) {
        const l2Collect = new Level2Collection(si, l2Type, ins);
        return l2Collect;
    }
    Clear() {
        this.itemsArr = [];
        this.items = {};
    }
    Add(quoteMsg) {
        // Добавление в список
        // Проверка цены, нужно ли удалить запись из таблицы
        const needToBeRemoved = isNaN(quoteMsg.Size) || quoteMsg.Closed;
        const topLevel2QuoteWasChanged = false;
        if (needToBeRemoved) {
            if (!isNullOrUndefined(this.items[quoteMsg.MMID])) {
                delete this.items[quoteMsg.MMID];
            }
        }
        else {
            const it = new Level2Item(quoteMsg, this.instrumentPrecision);
            this.items[quoteMsg.MMID] = it;
        }
        this.change = true;
        return topLevel2QuoteWasChanged;
    }
    GetSortedList(isBid) {
        const keys = Object.keys(this.items);
        const keysLen = keys.length;
        if (keysLen !== this.itemsArr.length) {
            this.itemsArr = Array(keysLen);
        }
        for (let i = 0; i < keysLen; i++) {
            this.itemsArr[i] = this.items[keys[i]];
        }
        if (isBid) {
            this.itemsArr.sort(Level2Collection.PriceComparerBid);
        }
        else {
            this.itemsArr.sort(Level2Collection.PriceComparerAsk);
        }
        return this.itemsArr;
    }
    static PriceComparerBid(a, b) {
        // if (isNaN(a.Quote.Price)) //#85713
        //     return 1;
        // if (isNaN(b.Quote.Price)) //#85713
        //     return -1;
        const xQuoteType = a.Quote ? a.Quote.QuoteType : null;
        const yQuoteType = b.Quote ? b.Quote.QuoteType : null;
        if (xQuoteType != Leve2QuoteType.None || yQuoteType != Leve2QuoteType.None) {
            return Level2Collection.PriceComparerByType(xQuoteType, yQuoteType);
        }
        if (a.Quote.Price < b.Quote.Price) {
            return 1;
        }
        return -1;
    }
    static PriceComparerAsk(a, b) {
        const xQuoteType = a.Quote ? a.Quote.QuoteType : null;
        const yQuoteType = b.Quote ? b.Quote.QuoteType : null;
        if (xQuoteType != Leve2QuoteType.None || yQuoteType != Leve2QuoteType.None) {
            return Level2Collection.PriceComparerByType(xQuoteType, yQuoteType);
        }
        if (a.Quote.Price > b.Quote.Price) {
            return 1;
        }
        return -1;
    }
    static PriceComparerByType(xQuoteType, yQuoteType) {
        // #42028 - если с сервера приходит -1, то необходимо такую котировку ставить в последнюю строку стакана.
        // #93376 - перевели с цены на дополнительный филд, так как цены 0 и -1 - это теперь валидные цены
        if (xQuoteType == yQuoteType) {
            return 0;
        }
        if (xQuoteType == Leve2QuoteType.Indicative) {
            return -1;
        }
        else if (xQuoteType == Leve2QuoteType.WithoutPrice) {
            return 1;
        }
        if (yQuoteType == Leve2QuoteType.Indicative) {
            return 1;
        }
        else if (yQuoteType == Leve2QuoteType.WithoutPrice) {
            return -1;
        }
    }
}
class Level2ItemComparer {
    constructor(reverse, CompateType, filter) {
        this.reverse = reverse;
        this.CompateType = CompateType || CompareType.Price;
        this.filter = filter || Filter.None;
    }
}
export class Level2Item {
    constructor(qMsg, instrumentPrecision, cacheDataForComparer = true) {
        // Ссылка на коировку
        this.Quote = null;
        this.Quote = qMsg;
        this.instrumentPrecision = instrumentPrecision;
        if (cacheDataForComparer && this.Quote != null) {
            this.UpdateRoundPrice();
            if (this.Quote != null) {
                this.CachedDateTime = this.Quote.cTime.getTime();
            }
        }
    }
    UpdateRoundPrice() {
        if (this.Quote === null) {
            return;
        }
        this.CachedRoundPrice =
            this.instrumentPrecision == -1
                ? this.Quote.Price
                : MathUtils.Round(this.Quote.Price, this.instrumentPrecision);
    }
}
